import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../services/analyticsService';

/**
 * Custom hook for automatic GA page tracking
 * Tracks page views for all routes automatically
 */
export const useGAPageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view whenever location changes
    const pageName = getPageName(location.pathname);
    analyticsService.trackPageView(pageName, location.pathname);
  }, [location]);
};

/**
 * Get a user-friendly page name from the pathname
 */
const getPageName = (pathname) => {
  // Remove leading slash and split by '/'
  const segments = pathname.replace(/^\//, '').split('/');
  
  // Handle different route patterns
  if (pathname === '/') return 'Dealer Login';
  if (pathname === '/DealerHome') return 'Dealer Home';
  if (pathname.startsWith('/CarDetail/')) return 'Car Details';
  if (pathname.startsWith('/mycars/')) {
    const step = segments[1];
    switch (step) {
      case 'inspection': return 'My Cars - Inspection';
      case 'upload-pictures': return 'My Cars - Upload Pictures';
      case 'place-bids': return 'My Cars - Place Bids';
      case 'payments': return 'My Cars - Payments';
      case 'take-delivery': return 'My Cars - Take Delivery';
      case 'noc': return 'My Cars - NOC';
      default: return 'My Cars';
    }
  }
  if (pathname.startsWith('/dealer/')) {
    const step = segments[1];
    switch (step) {
      case 'register': return 'Dealer Registration';
      case 'login': return 'Dealer OTP Login';
      case 'details': return 'Dealer Details';
      case 'subscription': return 'Dealer Subscription';
      case 'upload': return 'Upload Documents';
      case 'contract': return 'Dealer Contract';
      default: return 'Dealer Portal';
    }
  }
  if (pathname === '/analytics-test') return 'Analytics Test';
  if (pathname === '/unauthorized') return 'Unauthorized';
  if (pathname.startsWith('/evaluator')) return 'Evaluator Portal';
  if (pathname.startsWith('/driver')) return 'Driver Portal';
  
  // Default fallback
  return segments.map(segment => 
    segment.charAt(0).toUpperCase() + segment.slice(1)
  ).join(' - ') || 'Unknown Page';
};
